// Modelos del agente. Centralizado para que el Director (VideoEditor), el
// Asistente (useV2Chat) y la edge function `chat-agent` usen los mismos IDs.
//
// El edge function valida el `model` recibido contra una allow-list y aplica
// el pricing correcto por modelo (Opus es bastante más caro que Sonnet).

export const MODEL_SONNET = 'claude-sonnet-4-6';
export const MODEL_OPUS = 'claude-opus-4-8';
// Gemini Flash — nivel "baja" (ADR-608): hablar con el agente NO consume
// créditos del usuario (el costo lo absorbe Atlas). El ID es el de la
// allowlist del atlas (/v1/agent/chat), que lo mapea al modelo de Google y
// emite el MISMO stream SSE formato Anthropic que los demás.
export const MODEL_GEMINI_FLASH = 'gemini-3.6-flash';

// Nivel de "inteligencia" que elige el usuario en el Asistente.
//   baja  → Gemini Flash (default; gratis — no descuenta créditos).
//   media → Sonnet.
//   alta  → Opus (más potente, consume más créditos).
export type Intelligence = 'baja' | 'media' | 'alta';

export const intelligenceToModel = (lvl: Intelligence): string =>
  lvl === 'alta'
    ? MODEL_OPUS
    : lvl === 'baja'
      ? MODEL_GEMINI_FLASH
      : MODEL_SONNET;

export const INTELLIGENCE_LABEL: Record<Intelligence, string> = {
  baja: 'Baja',
  media: 'Media',
  alta: 'Alta',
};

// Créditos mínimos que el usuario debe tener para iniciar un turno con cada
// modelo. Es conservador: un turno con Opus puede costar varios créditos
// (sobre todo el que cambia de modelo, que paga la creación del cache a la
// tarifa de Opus). No arrancamos un request que el saldo no podría cubrir.
// Gemini Flash = 0: se puede chatear sin saldo (las generaciones que dispare
// el agente siguen cobrando lo suyo por su propio camino).
export const minCreditsForModel = (model: string): number =>
  model === MODEL_OPUS ? 6 : model === MODEL_GEMINI_FLASH ? 0 : 1;
